import { SampleFrameName, SampleQuantitiesRecord } from "kmmp/frontend";
import { toEntries } from "./sample-frame-quantities";

const sampleFrameRecord: Required<SampleQuantitiesRecord> = {
    Beige: 0,
    Black: 0,
    Honey: 0,
    Mahogany: 0,
    Vintage: 0,
};

/**
 * An array containing all of the Sample Frame names.
 */
export const SampleFrameNames: ReadonlyArray<SampleFrameName> =
    toEntries(sampleFrameRecord).map(kvp => kvp.key);
